import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import LocalizedStrings from 'react-localization';
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
import { ClientLanguage, getClientLanguageAsString } from "../../../../../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        weeklyWorkingHours: "Wöchentliche Stundenanzahl*",
        weeklyWorkingHoursPlaceholder: "(Maximal 5 Zeichen möglich)",
        weeklyWorkingHoursRequired: "Angabe ist erforderlich",
        weeklyWorkingHoursMaxCharacters: "Maximal 5 Zeichen möglich",

        remainingStudyTime: "Verbleibende Reststudienzeit in Semestern*",
        remainingStudyTimePlaceholder: "Maximal 5 Zeichen möglich",
    },
    en:
    {
        weeklyWorkingHours: "Weekly working hours*",
        weeklyWorkingHoursPlaceholder: "maximum 5 characters",
        weeklyWorkingHoursRequired: "Information required",
        weeklyWorkingHoursMaxCharacters: "maximum 5 characters",

        remainingStudyTime: "Remaining study time in semesters*",
        remainingStudyTimePlaceholder: "maximum 5 characters",
    }
});

function setLanguage(clientLanguage): void {
    switch(clientLanguage) { 
        case ClientLanguage.German: { 
           locStrings.setLanguage('de');
           break; 
        } 
        case ClientLanguage.English: { 
           locStrings.setLanguage('en'); 
           break; 
        } 
        // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
    } 
}

export const Schema = (settings, clientLanguage) => Yup.object().shape({
    weeklyWorkingHours: Yup.string()
            .required(() => {
                    setLanguage(clientLanguage);
                    return locStrings.weeklyWorkingHoursRequired})
            .max(5,() => {
                    setLanguage(clientLanguage);
                    return locStrings.weeklyWorkingHoursMaxCharacters;
            }),
    remainingStudyTime: Yup.string()
            .required(() => {
                    setLanguage(clientLanguage);
                    return locStrings.weeklyWorkingHoursRequired})
            .max(5,() => {
                    setLanguage(clientLanguage);
                    return locStrings.weeklyWorkingHoursMaxCharacters;
            }),
});

export const WorkingStudentDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings, clientLanguage } = props;

    setLanguage(clientLanguage);

    function getClientLanguage(): string { 
        return getClientLanguageAsString(clientLanguage); 
    } 
    
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formWeeklyWorkingHours">
                    <Form.Label className={"FormWeeklyWorkingHoursText"}>{locStrings.weeklyWorkingHours}</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder={locStrings.weeklyWorkingHoursPlaceholder}
                        type="text"
                        name="weeklyWorkingHours"
                        value={values.weeklyWorkingHours}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onInput={handleBlur}
                        isValid={touched.weeklyWorkingHours && !errors.weeklyWorkingHours}
                        isInvalid={touched.weeklyWorkingHours && errors.weeklyWorkingHours}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.weeklyWorkingHours}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formRemainingStudyTime">
                    <Form.Label className={"FormRemainingStudyTimeText"}>{locStrings.remainingStudyTime}</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder={locStrings.remainingStudyTimePlaceholder}
                        type="text"
                        name="remainingStudyTime"
                        value={values.remainingStudyTime}
                        onChange={handleChange}
                        onInput={handleBlur}
                        onBlur={handleBlur}
                        isValid={touched.remainingStudyTime && !errors.remainingStudyTime}
                        isInvalid={touched.remainingStudyTime && errors.remainingStudyTime}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.remainingStudyTime}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};